var map = {
	"./arrow.svg": 230,
	"./gi-logo-text.svg": 231,
	"./gi-logo.svg": 232,
	"./icon-arrow-down.svg": 233,
	"./icon-close.svg": 234,
	"./icon-fb-neg.svg": 235,
	"./icon-fb-pos.svg": 236,
	"./icon-gfx.svg": 237,
	"./icon-gi-logo.svg": 238,
	"./icon-knowledge.svg": 239,
	"./icon-logo-neg.svg": 240,
	"./icon-logo-spinner.svg": 241,
	"./icon-news-neg.svg": 242,
	"./icon-news-pos.svg": 243,
	"./icon-play.svg": 244,
	"./icon-plus.svg": 245,
	"./icon-search.svg": 246,
	"./logo-simple-neg.svg": 247,
	"./user.svg": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;